import React from "react";
import { Link as RouterLink } from "react-router-dom";

import ListItemIcon from "@material-ui/core/ListItemIcon";

import { List, ListItem, ListItemText, ListSubheader } from "@material-ui/core";

import { Container } from "./styles";

type Props = {
  match: any;
  items: {
    route: string;
    title: string;
    disabled?: boolean;
    icon?: React.ReactNode;
    rootRoute?: string;
  }[];
  subheader?: string;
  className?: string;
};

const NavMenu = ({ className, items, match, subheader }: Props) => {
  return (
    <Container className={className}>
      <List
        subheader={
          subheader ? (
            <ListSubheader color="default">{subheader}</ListSubheader>
          ) : (
            undefined
          )
        }
      >
        {items.map(({ route, rootRoute, title, disabled, icon }) => (
          <ListItem
            component={RouterLink}
            key={`${route}-${title}`}
            to={route}
            selected={match.url.includes(rootRoute || route)}
            disabled={disabled}
          >
            {icon && <ListItemIcon>{icon}</ListItemIcon>}
            <ListItemText primary={title} />
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default NavMenu;
